export default {
  ["agent_admin"]: `Quản trị viên đại lý`,
  ["edit_pwd"]: `Chỉnh sửa mật khẩu`,
  ["logout"]: `Đăng xuất`,
  ["login"]: `Đăng nhập`,
  ["register"]: `Đăng ký`,
  ["dashboard"]: `Bảng điều khiển`,
  ["registration"]: `Đăng ký`,
  ["incomes"]: `Thu nhập`,
  ["record"]: `Hồ sơ`,
  ["rules"]: `Quy định`,
  ["account"]: `Tài khoản`,
  ["account_ph"]: `Vui lòng nhập tài khoản chính xác.`,
  ["password"]: `Mật khẩu`,
  ["password_ph"]: `Vui lòng nhập mật khẩu chính xác.`,
  ["remember_account"]: `Nhớ tài khoản`,
  ["invite_ratio"]: `Mời người chơi để nhận thưởng`,
  ["invite_ratio_desc"]: `Lợi nhuận và thua lỗ thanh toán ròng`,
  ["product_fee_ratio"]: `Phí sản phẩm`,
  ["product_fee_ratio_desc"]: `Lợi nhuận và thua lỗ thanh toán ròng`,
  ["register_count"]: `Đăng ký`,
  ["login_count"]: `Đăng nhập`,
  ["deposit_count"]: `Nạp tiền`,
  ["first_deposit_count"]: `Nạp tiền lần đầu`,
  ["deposit_amount"]: `Nạp tiền`,
  ["withdraw_amount"]: `Rút tiền`,
  ["valid_bet_amount"]: `Cược hợp lệ`,
  ["win_amount"]: `Thắng`,
  ["bonus_amount"]: `Thưởng`,
  ["profit_amount"]: `Thắng/Thua`,
  ["link_manage"]: `Quản lý liên kết`,
  ["add_link"]: `Thêm liên kết`,
  ["link_reached_limit"]: `Đã đạt giới hạn`,
  ["copy_success"]: `Sao chép thành công`,
  ["submit"]: `Gửi đi`,
  ["cancel"]: `Hủy`,
  ["download"]: `Tải xuống`,
  ["sub_domain"]: `Tên miền phụ`,
  ["sub_domain_ph"]: `Vui lòng nhập tên miền phụ hợp lệ.`,
  ["tag_name"]: `Tên thẻ`,
  ["tag_name_ph"]: `Vui lòng nhập tên thẻ hợp lệ.`,
  ["link_status_0"]: `Không trạng thái`,
  ["link_status_1"]: `Đang khởi tạo`,
  ["link_status_2"]: `Có hiệu lực`,
  ["link_status_3"]: `Có thể thử lại`,
  ["link_sttaus_4"]: `Không có sẵn`,
  ["month"]: `Tháng`,
  ["active_user_count"]: `Người dùng hoạt động`,
  ["product_fee_amount"]: `Phí sản phẩm`,
  ["dividend_ratio"]: `Tỷ lệ`,
  ["dividend_amount"]: `Hoa hồng`,
  ["status"]: `Trạng thái`,
  ["dividend_bill_status_0"]: `Đang tiến hành`,
  ["dividend_bill_status_4"]: `Đang chờ`,
  ["dividend_bill_status_9"]: `Đã thanh toán`,
  ["month_phase_1"]: `Hiệp một`,
  ["month_phase_2"]: `Hiệp hai`,
  ["click_here"]: `Nhấp vào đây`,
  ["click_here_desc"]: `Để liên hệ với quản lý tài khoản của bạn về việc rút USDT`,
  ["available_commission"]: `Hoa hồng có sẵn`,
  ["time"]: `Thời gian`,
  ["affiliate_program"]: `Chương trình liên kết`,
  ["active_user_desc"]: `Số người dùng có tổng số tiền gửi vượt quá 300.000 trong suốt`,
  ["payout_instructions"]: `Hướng dẫn thanh toán`,
  ["payout_instructions_detail"]: `<li>Mỗi tháng dương lịch được thanh toán hai lần.<li>
<li>Thời gian thanh toán 1: Từ ngày 1 đến ngày 15 của mỗi tháng (thanh toán vào ngày 20).<li>
<li>Thời gian thanh toán 2: Từ ngày 16 đến ngày cuối cùng của tháng (thanh toán vào ngày 5 của tháng sau).<li>`,
  ["rules_detail"]: `Chỉ những người chơi đăng ký qua liên kết giới thiệu của đại lý mới đủ điều kiện nhận cổ tức.</br>
Mỗi đại lý phải chia sẻ các chi phí quản lý thực tế và chi phí quảng bá phát sinh từ các thành viên của họ. Các chi phí này sẽ được trừ vào kỳ có lãi tiếp theo.</br>
Chỉ các đại lý hợp lệ mới có thể nhận cổ tức (ít nhất 5 người dùng hoạt động trong vòng 2 tuần).</br>
Nếu lợi nhuận âm trong tháng chuyển thành dương, đại lý sẽ không nhận cổ tức, và lợi nhuận âm sẽ được chuyển sang tháng tiếp theo.</br>
Mọi người dùng hoặc nhóm tham gia vào các hoạt động chênh lệch giá bất thường sẽ bị hủy cổ tức. Trong những trường hợp nghiêm trọng, các tài khoản liên quan có thể bị đóng băng hoặc đóng mà không thông báo trước, và tiền sẽ không được hoàn lại. Những người dùng này cũng sẽ bị đưa vào danh sách đen.</br>
Để ngăn chặn việc lạm dụng và vi phạm các chính sách và khuyến mãi của chúng tôi, bộ phận kiểm soát rủi ro sẽ kiểm tra nghiêm ngặt từng tài khoản đại lý (bao gồm tên, email, số điện thoại, v.v.). Nếu phát hiện bất kỳ tài khoản nào tham gia vào hoạt động chênh lệch giá hoặc lạm dụng khuyến mãi liên quan đến các đại lý khác, chúng tôi có quyền hủy bỏ và tịch thu số dư của tài khoản đại lý và các tài khoản liên quan mà không thông báo trước.</br>
Chúng tôi có quyền từ chối hoặc đóng băng tài khoản của bất kỳ đại lý hoặc thành viên đối tác nào.</br>`,
  ["get_withdraw"]: `Nhận cổ tức`,
  ["commission_history"]: `Lịch sử cổ tức`,
  ["link_capacity"]: `Tạo liên kết`,
  ["language"]: `Ngôn ngữ`,
  ["old_password"]: `Mật khẩu cũ`,
  ["old_password_ph"]: `Vui lòng nhập mật khẩu cũ`,
  ["new_password"]: `Mật khẩu mới`,
  ["new_password_ph"]: `Vui lòng nhập mật khẩu mới`,
  ["confirm_password"]: `Xác nhận mật khẩu`,
  ["confirm_password_ph"]: `Vui lòng xác nhận mật khẩu`,
  ["confirm_password_not_same"]: `Mật khẩu không khớp`,
  ["operation_success"]: `Hoạt động thành công`,
  ["need_change_pwd_title"]: `Tài khoản cần thay đổi mật khẩu`,
  ["need_change_pwd_content"]: `Tài khoản cần thay đổi mật khẩu`,
  ["need_change_pwd_confirm"]: `Đi đến chỉnh sửa`,
  ["err_5001"]: `Lỗi nội bộ: Khóa không thành công`,
  ["err_5002"]: `Lỗi nội bộ: Xung đột khóa`,
  ["err_5003"]: `Lỗi tham số`,
  ["err_6001"]: `Đăng nhập bị chặn thất bại`,
  ["err_6003"]: `Đã đạt giới hạn liên kết, không thể thêm nữa, tạo liên kết trùng lặp thất bại`,
  ["err_6004"]: `Xung đột khi tạo liên kết`,
  ["err_2003"]: `Mật khẩu không hợp lệ`,
  ["err_2014"]: `Tên người dùng không hợp lệ`,
  ["date_picker_today"]: `Hôm nay`,
  ["date_picker_yesterday"]: `Hôm qua`,
  ["date_picker_7_days"]: `7 ngày qua`,
  ["date_picker_30_days"]: `30 ngày qua`,
  ["date_picker_this_month"]: `Tháng này`,
  ["select_date_range"]: `Vui lòng chọn ngày`,
  ["date_picker_ok"]: `Đồng ý`,
  ["start_date"]: `Ngày bắt đầu`,
  ["end_date"]: `Ngày kết thúc`,
  ["date_picker_year"]: `Năm`,
  ["date_picker_month"]: `Tháng`,
  ["date_picker_day"]: `Ngày`,
}